__turbopack_context__.v({
  "appDownloadContainer": "styles-module__pb-Myq__appDownloadContainer",
  "buttonContainer": "styles-module__pb-Myq__buttonContainer",
  "depopSticker": "styles-module__pb-Myq__depopSticker",
  "downloadButtonContainer": "styles-module__pb-Myq__downloadButtonContainer",
  "horizontalBreak": "styles-module__pb-Myq__horizontalBreak",
  "horizontalBreakContainer": "styles-module__pb-Myq__horizontalBreakContainer",
  "loginButton": "styles-module__pb-Myq__loginButton",
  "modalBodyText": "styles-module__pb-Myq__modalBodyText",
  "modalContainer": "styles-module__pb-Myq__modalContainer",
  "modalTitle": "styles-module__pb-Myq__modalTitle",
  "orText": "styles-module__pb-Myq__orText",
  "signupButton": "styles-module__pb-Myq__signupButton",
});
